export const solutions = [
  {
    id: 'enterprise',
    title: '央国企',
    iconName: 'building',
    subtitle: '数据治理与文档智能处理一体化方案',
    description: '面向央国企集团，将业务系统数据与制度、合同、工程档案、历史资料纳入统一治理。通过文档解析、结构化提取、质量复核与证据追溯，把资料沉淀为可交付的数据资产，支撑知识检索、经营分析与业务决策。',
    features: [
      { iconName: 'schema', title: '统一数据标准', desc: '建立全集团统一的数据标准体系，消除数据孤岛' },
      { iconName: 'extraction', title: '智能文档处理', desc: '接入 PDF、Word、Excel 与扫描件，通过可复用方案实现分类、解析和结构化提取' },
      { iconName: 'quality', title: '质量复核与数据交付', desc: '字段关联原文证据，质量门禁与人工复核衔接成果入库和交付回执' },
      { iconName: 'security', title: '合规治理', desc: '满足国资委数据合规要求，支持数据安全审计' },
      { iconName: 'model', title: '私有化部署', desc: '完全本地化部署，数据不出企业边界' },
      { iconName: 'access', title: 'SaaS 租户服务', desc: '提供租户开通、在线使用与持续升级服务' },
    ],
    tags: ['数据治理', '文档处理', '结构化提取', '证据追溯', '私有化', 'SaaS 服务'],
  },
  {
    id: 'government',
    title: '智慧政务',
    iconName: 'building',
    subtitle: '政务数据开放共享与协同治理',
    description: '构建统一政务数据底座，打通跨部门数据壁垒，支撑"一网通办"、"一网统管"等政务数字化转型核心场景。',
    features: [
      { iconName: 'catalog', title: '数据汇聚', desc: '汇聚多部门异构数据，统一数据标准与编码' },
      { iconName: 'integration', title: '跨部门共享', desc: '建立数据共享机制，实现政务数据有序流转' },
      { iconName: 'security', title: '安全可控', desc: '数据分级分类管理，权限管控精细可审计' },
      { iconName: 'analytics', title: '可视化决策', desc: '政务数据看板与分析，支撑领导科学决策' },
    ],
    tags: ['政务数据', '数据共享', '一网通办', '安全合规'],
  },
  {
    id: 'energy',
    title: '能源电力',
    iconName: 'action',
    subtitle: '能源电力智能数据中枢',
    description: '面向能源电力行业，构建设备运维、生产调度、经营分析一体化数据智能平台，赋能企业降本增效与安全生产。',
    features: [
      { iconName: 'engine', title: '设备数据接入', desc: '实时接入生产设备传感器与 SCADA 数据' },
      { iconName: 'operations', title: '预测性维护', desc: '基于数据模型预测设备故障，降低非计划停机' },
      { iconName: 'workflow', title: '调度优化', desc: '生产调度数据集成，提升电网调配效率' },
      { iconName: 'analytics', title: '经营分析', desc: '全链路经营数据看板，支撑管理层决策' },
    ],
    tags: ['IoT接入', '预测维护', '实时监控', '经营分析'],
  },
  {
    id: 'manufacturing',
    title: '智能制造',
    iconName: 'factory',
    subtitle: '制造业数字化升级解决方案',
    description: '融合 MES、ERP、质检等系统数据，构建制造业数字孪生与质量追溯体系，助力企业迈向智能制造新阶段。',
    features: [
      { iconName: 'connection', title: '生产数据集成', desc: '打通 MES/ERP 等系统数据，全流程可见可控' },
      { iconName: 'quality', title: '质量追溯', desc: '产品全生命周期质量数据追踪，问题快速定位' },
      { iconName: 'configuration', title: '工艺优化', desc: '基于数据分析优化生产工艺，提升良品率' },
      { iconName: 'assets', title: '供应链协同', desc: '上下游数据共享，供应链透明化管理' },
    ],
    tags: ['MES集成', '质量追溯', '工艺优化', '供应链'],
  },
]
